import './index.scss';

import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

const Modal = ({children, onClose, contentClassName = ''}) => {
	useEffect(() => {
		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = 'unset';
		};
	}, []);

	return (
		<div className="modal-backdrop">
			<div className={['modal-content', contentClassName].filter(Boolean).join(' ')}>
				{children}
			</div>
			<button
				type="button"
				className="modal-backdrop__dismiss"
				aria-label="Close dialog"
				tabIndex={-1}
				onClick={onClose}
			/>
		</div>
	);
};

Modal.propTypes = {
	children: PropTypes.node.isRequired,
	onClose: PropTypes.func.isRequired,
	contentClassName: PropTypes.string
};

export default Modal;
